import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import { Tooltip } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Modal from '@mui/material/Modal';
import DatePicker from 'react-datepicker';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function ExpenseEntryPage() {
    const history = useHistory();

    // Define necessary states
    const [note, setNote] = useState('');
    const [amount, setAmount] = useState('');
    const [itemList, setItemList] = useState([]);
    const [newItem, setNewItem] = useState({});
    const [selectedOption, setSelectedOption] = useState('');
    const [cards, setCards] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    useEffect(() => {

        if (isAuthenticated && tokenIsExpired(token)) {

            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    const handleExpenseNameChange = (e) => {
        setNote(e.target.value);
    };

    const handleAmountChange = (e) => {
        setAmount(e.target.value);
    };

    const [ExpenseTypeOptions, setExpenseTypeOptions] = useState([]);
    const [selectedExpenseType, setSelectedExpenseType] = useState("");

    const fetchExpenseTypes = async () => {
        try {
            const response = await fetchData('ExpenseTypeApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(customer => ({
                    value: customer.name,
                    label: customer.name
                }));
                setExpenseTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Expense Types:', error);
        }
    };

    const handleExpenseTypeChange = (selectedOption) => {
        setSelectedExpenseType(selectedOption);
    };

    useEffect(() => {
        fetchExpenseTypes();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();


        setSelectedExpenseType('');
        setNote('');
        setAmount('');
    };

    const AddtoListdata = (e) => {
        e.preventDefault();

        const updatedItem = { ...newItem };

        updatedItem.Note = note;
        updatedItem.Amount = amount;
        updatedItem.selectedExpenseType = selectedExpenseType.label;

        setItemList([...itemList, updatedItem]);

        setNewItem({
            ExpenseType: '',
            Note: '',
            Amount: 0,
            ...(selectedOption === 'spare' && { ExpenseType: selectedExpenseType })
        });
        setSelectedExpenseType('');
        setNote('');
        setAmount('');
    };

    const submitListData = async () => {
        try {
            if (itemList.length === 0) {

                return;
            }

            const ExpenseItems = itemList.map((item) => {

                return {
                    CompanyId: companyId,
                    ExpenseType: item.selectedExpenseType,
                    Note: item.Note,
                    Amount: item.Amount,
                };
            });

            const ExpenseHead = {
                CompanyId: companyId,
                EngineerID: userId,
                ExpenseEntryDate: selectedDate,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            const CreatedData = {
                expense: ExpenseHead,
                expenseItem: ExpenseItems,
            };

            postData('ExpenseApi', CreatedData)
                .then((response) => {
                    console.log('Data Created success:', response);
                    history.push('/Index');
                    setTimeout(() => {
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Data Create error:', error);
                });
        }
        catch (error) {
            console.error('Data Create error:', error);
        }
    };

    const formatCurrentDate = () => {
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const year = currentDate.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const formattedDate = formatCurrentDate();

    const handleDelete = (index) => {
        const updatedList = [...itemList];
        updatedList.splice(index, 1);
        setItemList(updatedList);
    };

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };



    return (


        <div className="w-full max-w-sm container mt-6 mx-auto">
            <div className='w-full mb-2 flex'>
                {/* <h4 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black' }}>Daily Expense</h4> */}
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>DAILY EXPENSE CREATE</h6>

                <div className="button-container-2">

                    <Tooltip title="Exit">
                        <Link to="/Index" style={{ marginTop: '-30px', color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                            <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                Cancel <ArrowForwardIosIcon />
                            </Button>
                        </Link>
                    </Tooltip>

                    <Tooltip title="Submit">

                        <Button onClick={submitListData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Submit"} <CheckCircleIcon />
                        </Button>

                    </Tooltip>
                </div>
            </div >
            {!isModalOpen && (
                //<Button onClick={openModal} style={{ marginTop: '-20px', color: 'brown' , backgroundColor:'whitesmoke',fontWeight:'bolder'}}>+ Add</Button>
                <Button onClick={openModal} style={{ marginTop: '-20px', color: 'white', backgroundColor: 'black', fontWeight: 'bolder', height: '20px' }}>+ Add</Button>
            )}

            <Modal open={isModalOpen} className={isModalOpen ? 'notification-modal' : ''}>
                <div className="notification-modal" style={{ backgroundColor: 'white', maxHeight: '400px' }}>
                    <br></br>
                    <h4 style={{ textAlign: 'center', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'darkred' }}>Add Expense</h4>
                    <div className="bg-tabcolor-100 rounded-lg shadow-lg p-6">


                        <div className="w-full mb-4 flex">
                            <div className="w-1/7 mr-3" style={{ marginTop: '-20px' }}>
                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                                    Date
                                </label>
                                <DatePicker
                                    selected={selectedDate}
                                    onChange={date => setSelectedDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                />
                            </div>
                            <div className="w-1/7 mr-3" style={{ width: '275px', marginTop: '-20px' }}>
                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                                    Expense
                                </label>
                                <Select
                                    value={selectedExpenseType}
                                    onChange={handleExpenseTypeChange}
                                    options={ExpenseTypeOptions}
                                    placeholder="--Expense--"
                                    isSearchable
                                />
                            </div>
                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/7 mr-3" style={{ width: '400px', marginTop: '-22px' }}>
                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingSlipNumber" style={{ fontSize: '16px' }}>
                                    Note
                                </label>
                                <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                    placeholder="Enter Notes"
                                    rows={3}
                                    maxLength={250}
                                />
                            </div>
                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-full md:w-1/2 pr-2" style={{ marginTop: '-20px', width: '150px' }}>
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={amount}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*\.?\d*$/.test(value)) {
                                            setAmount(value);
                                        }
                                    }}
                                    pattern="^\d*\.?\d*$"
                                    maxLength={5}
                                />
                            </div>
                        </div>
                        <br></br>
                        <div className="w-full mb-4 flex">

                            <Tooltip title="Add">
                                <Button onClick={AddtoListdata} style={{ marginTop: '-30px', color: 'green', cursor: 'pointer' }}>
                                    ADD <CheckCircleIcon />
                                </Button>
                            </Tooltip>

                            <Tooltip title="Cancel">
                                <Button onClick={closeModal} style={{ marginTop: '-30px', color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}>
                                    Cancel<CancelIcon />
                                </Button>
                            </Tooltip>
                        </div>
                    </div>
                </div>

            </Modal>
            <div className="overflow-auto" style={{ overflowY: 'auto' }}>
                <table className="w-full border-collapse border" style={{ overflowY: 'auto' }}>
                    <thead>
                        <tr className="bg-gray-200 border-b">
                            <th className="px-4 py-2 text-left border-r" style={{ width: '5px' }}>Sl.no</th>
                            <th className="px-4 py-2 text-left border-r" style={{ width: '500px' }}>Expense</th>
                            <th className="px-4 py-2 text-left border-r" style={{ width: '500px' }}>Note</th>
                            <th className="px-4 py-2 text-left border-r" style={{ width: '75px' }}>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemList.map((item, index) => (
                            <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}>
                                <td className="px-4 py-2 border-r" style={{ width: '5px' }}>{index + 1}</td>
                                <td className="px-4 py-2 border-r" style={{ width: '500px' }}>{item.selectedExpenseType}</td>
                                <td className="px-4 py-2 border-r" style={{ width: '500px' }}>{item.Note}</td>
                                <td className="px-4 py-2 border-r" style={{ width: '75px', textAlign: 'right', cursor: 'pointer' }} onClick={() => handleDelete(index)}>{item.Amount} <Tooltip title="Delete"><DeleteIcon style={{ color: 'brown' }} /></Tooltip></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>


        </div >
    );
}

export default ExpenseEntryPage;
